import { createTheme } from '@mui/material';

export const AiBotTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#026CCF',
      light: '#026CCF',
      dark: '#026CCF',
    },
    secondary: {
      main: '#5479a0',
      light: '#5479a0',
      dark: '#5479a0',
    },
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          // Some CSS
          //margin: '0px !important',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          lineHeight: '1em',
        },
      },
    },
  },
});

export default AiBotTheme;